import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-lti',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class SSOLTI extends Vue {

    @Prop()
    public isEditAllow: any;

    @Prop()
    public ssoFields: any;

    public onBack() {
        this.$emit('onBack');
    }

    public onEdit() {
        this.$emit('onEdit');
    }

    public onSubmit() {
        this.$emit('onSubmit', this.ssoFields);
    }

}
